const colors = {
  secondary: '#03344A',
  primary: '#E46A15',
  gray: '#8F8F8F',
  cararra: '#EFF0EA',
  white: '#FFFFFF'
}

export { colors }
